<div class="gb-recaptcha-privacy-terms flex-row-center">
  <span [innerHtml]="'GRECAPTCHA_PRIVACY_TERMS' | translate | gbSafe: 'html'"></span>
</div>
